import { Controller } from '@hotwired/stimulus';

// Updates duration selection styling and the shared time/progress indicator UI.
export default class extends Controller {
  static targets = [
    'durationInput',
    'resumeTime',
    'resumeTimeText',
    'progressBar',
  ];

  static values = {
    progressMap: Object, // e.g. { "5": 8, "10": 17, "30": 50, "60": 100 }
  };

  connect() {
    this.updatePreview();
  }

  updatePreview() {
    const selectedInput = this.durationInputTargets.find(
      (input) => input.checked
    );
    if (!selectedInput) return;

    const minutes = parseInt(selectedInput.value, 10);

    const resumeTime = new Date(Date.now() + minutes * 60 * 1000);
    const timeString = resumeTime.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    this.resumeTimeTargets.forEach((el) => (el.textContent = timeString));
    this.resumeTimeTextTargets.forEach((el) => (el.textContent = timeString));

    const progressMap = this.hasProgressMapValue ? this.progressMapValue : {};
    const progress = progressMap[minutes.toString()] || 50;
    this.progressBarTargets.forEach((el) => (el.style.width = `${progress}%`));
  }
}
